<!--
  - Copyright Huesik (c) 2019.
  -->

<template>
  <div class="wrapper" :class="classes">
    <slot></slot>
  </div>
</template>

<script>
  export default {
    name: 'MainLayout',
    props: {
      classes: {
        type: String,
        default: ''
      }
    }
  }
</script>

<style scoped>
  .wrapper {
    margin-right: auto;
    margin-left: auto;
    max-width: 2560px;
    height: 100%;
  }
</style>
